var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{staticClass:"empty-card"},[_vm._v("\n  Your search did not have any results.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }